import React, { Fragment, useContext, useState } from "react";
import { Col, Container, Form, FormGroup, Label, Row } from "reactstrap";
import SharedDataContext from "../../../_helper/SharedData";
import { useForm } from "react-hook-form";
import { showAlert } from "../../../Services/Shared.service";
import { getDriversByName, rechargeDriver } from "../../../Services/Driver.service";
import CustomAutoSuggest from "../../../CommonElements/CustomAutoSuggest";
const DriverRecharge = () => {
    const {
        register,
        handleSubmit,
        control,
        reset,
        resetField,
        getValues,
        setValue,
        watch,
        formState: { errors },
    } = useForm();
    const { setShowApiLoader, globalCityField, cityData } =
        useContext(SharedDataContext);
    const [isSubmitting, setIsSubmitting] = useState(false)

    const handleSelect = (data) => {
        const value = data.value;
        console.log(value, "value");
        setValue("driverId", value?.id);
        setValue("driverName", value?.fullName)
    };

    const searchCustomers = async (inputValue) => {
        const serviceCityId = globalCityField.value?.id || null;
        if (inputValue) {
            let obj = {
                inputValue,
                serviceCityId
            }
            return getDriversByName(obj).then((result) => {
                if (result.data.driverList.length > 0) {
                    let data = result.data.driverList.map((element) => {
                        return {
                            value: element,
                            label: element.fullName,
                        };
                    });
                    return data;
                }
                return [];
            });
        }
    };


    const onSubmit = (formValues) => {
        setShowApiLoader(true)
        setIsSubmitting(true)
        const obj = {
            rechargeDriverId: formValues.driverId,
            amount: Number(formValues.amount),
            transactionType: "Recharge",
            transactionMode: 1,
            isAirportCounter: true,
            paymentType: "Cash",
            remarks: formValues.remarks,
            isDriverCollectableRecharge: false
        };
        rechargeDriver(obj).then(result => {
            setShowApiLoader(false);
            setIsSubmitting(false);
            reset()
            showAlert('success', 'Driver recharged Successfully');
        }).catch(err => {
            setShowApiLoader(false);
            setIsSubmitting(false)
            showAlert('error', err.response?.data?.message ? err.response.data.message : 'Something went wrong');
        })
    }


    return (
        <Fragment>
            <Container fluid={true} style={{ padding: "30px 0px" }}>
                <Row style={{ justifyContent: "center", fontSize: "20px" }}>Driver Recharge</Row>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <FormGroup className="col-lg-12">
                        <Label className="col-lg-4 col-form-label">
                            Driver Name
                        </Label>
                        <Col lg="12">
                            <CustomAutoSuggest
                                id={"Driver Name"}
                                registerName={"driverName"}
                                handleSelectChange={handleSelect}
                                options={searchCustomers}
                                placeholder={"Enter Driver Name"}
                                register={register}
                                inputType={"text"}
                                inputProps={{
                                    required: {
                                        value: true,
                                        message: "Driver name is required",
                                    }
                                }}
                                dependentRegisterName={""}
                            />
                            <span style={{ color: "red" }}>
                                {errors?.phoneNumber?.message}
                            </span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-12">
                        <Label className="col-lg-12 col-form-label">Recharge Amount</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("amount", {
                                    required: {
                                        value: true,
                                        message: "Recharge Amount is required",
                                    },
                                    onChange: (e) => {
                                        let value = e.target.value.replace(/[^\d.-]/g, '');
                                        let sanitizedValue = value.replace(/(\.|\-)(?=.*\1)/g, '');
                                        setValue("amount", sanitizedValue)
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.amount?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-12">
                        <Label className="col-lg-12 col-form-label">Remarks</Label>
                        <Col lg="12">
                            <textarea
                                className="form-control"
                                {...register("remarks", {
                                    required: {
                                        value: true,
                                        message: "Remarks is required"
                                    },
                                    onChange: (e) => {
                                        setValue("remarks", e.target.value.trimStart())
                                    }
                                })}
                                type="text"
                            />
                            <span style={{ color: "red" }}>{errors?.remarks?.message}</span>
                        </Col>
                    </FormGroup>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <button type="submit" className="btn submit-button" disabled={isSubmitting}>
                            Recharge
                        </button>
                    </div>
                </Form>
            </Container>
        </Fragment>
    );
};

export default DriverRecharge;
